import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Auth';

const LogoutButton: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await auth.signout();
    } catch {
      // signout API call may fail (e.g. expired session); proceed anyway
    }
    navigate('/login', { replace: true });
  };

  return (
    <button onClick={logout} className="text-left w-full">
      Logout
    </button>
  );
};

export default LogoutButton;